import {
  clearAuthToken,
  clearRefreshToken,
} from './authTokenStorage'

function stringifyErrorPayload(payload) {
  if (!payload) return ''
  if (typeof payload === 'string') return payload
  if (typeof payload.detail === 'string') return payload.detail
  if (typeof payload.message === 'string') return payload.message
  if (typeof payload.error === 'string') return payload.error

  try {
    return JSON.stringify(payload)
  } catch {
    return ''
  }
}

export function isSubscriptionExpiredError(error) {
  if (error?.response?.status !== 403) return false
  return stringifyErrorPayload(error.response.data)
    .toLowerCase()
    .includes('subscription expired')
}

export function handleSubscriptionExpiredSession() {
  if (typeof window === 'undefined') return
  if (window.__growchatSubscriptionExpiredHandled) return
  window.__growchatSubscriptionExpiredHandled = true

  clearAuthToken()
  clearRefreshToken()
  window.dispatchEvent(new Event('auth:subscription-expired'))

  if (window.location.pathname !== '/login') {
    window.location.assign('/login')
  }
}
